document.addEventListener('DOMContentLoaded', function() {
    /* ================================================
       WATER MODES — tab switcher
    ================================================ */
    const modeTabs = document.querySelectorAll('.modes-tab');
    const modePanels = document.querySelectorAll('.mode-panel');

    // Only run tab switcher if both tabs and panels exist
    if (modeTabs.length && modePanels.length) {
        modeTabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const mode = tab.dataset.mode;
                modeTabs.forEach(t => {
                    t.classList.remove('is-active');
                    t.setAttribute('aria-selected', 'false');
                });
                modePanels.forEach(p => p.classList.remove('is-active'));
                tab.classList.add('is-active');
                tab.setAttribute('aria-selected', 'true');
                const panel = document.querySelector(`.mode-panel[data-mode="${mode}"]`);
                if (panel) panel.classList.add('is-active');
            });
        });
    }

    /* ================================================
       EXPANDABLE FEATURE CARDS — inline (desktop) + bottom-sheet (mobile)
    ================================================ */
    const featuresSection = document.querySelector('.s-features');

    // Only proceed if the features section exists
    if (!featuresSection) return;

    const featureSheet    = document.getElementById('feature-sheet');
    const sheetBackdrop   = document.getElementById('feature-sheet-backdrop');
    const sheetClose      = document.getElementById('feature-sheet-close');
    const sheetTitle      = document.getElementById('feature-sheet-title');
    const sheetBody       = document.getElementById('feature-sheet-body');
    const sheetList       = document.getElementById('feature-sheet-list');
    const featureAnnounce = document.getElementById('feature-announce');
    const featuresScrim   = document.getElementById('features-scrim');

    function isMobile() {
        return window.innerWidth <= 768;
    }

    function openSheet(card) {
        // Guard: ensure sheet elements exist
        if (!sheetTitle || !sheetBody || !sheetList || !sheetBackdrop || !featureSheet || !sheetClose) return;

        const title = card.querySelector('h3')?.textContent || '';
        const body  = card.querySelector('.feature-card-extra-inner p')?.textContent || '';
        const items = card.querySelectorAll('.feature-card-extra-inner li');

        sheetTitle.textContent = title;
        sheetBody.textContent  = body;
        sheetList.innerHTML    = Array.from(items).map(li => `<li>${li.innerHTML}</li>`).join('');

        sheetBackdrop.classList.add('is-open');
        sheetBackdrop.removeAttribute('aria-hidden');
        featureSheet.classList.add('is-open');
        if (featureAnnounce) featureAnnounce.textContent = title + ' expanded';
        sheetClose.focus();
        document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
        if (!featureSheet || !sheetBackdrop) return;
        featureSheet.classList.remove('is-open');
        sheetBackdrop.classList.remove('is-open');
        sheetBackdrop.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    // Attach sheet close events only if required elements exist
    if (sheetClose) sheetClose.addEventListener('click', closeSheet);
    if (sheetBackdrop) sheetBackdrop.addEventListener('click', closeSheet);
    if (featureSheet) {
        featureSheet.addEventListener('keydown', e => {
            if (e.key === 'Escape') closeSheet();
        });
    }

    // Feature card toggles
    const toggleButtons = document.querySelectorAll('.feature-card-toggle');
    if (toggleButtons.length) {
        toggleButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                const card = btn.closest('.feature-card');
                if (!card) return;

                if (isMobile()) {
                    openSheet(card);
                    return;
                }

                const isExpanded = card.classList.contains('is-expanded');
                document.querySelectorAll('.feature-card').forEach(c => c.classList.remove('is-expanded'));
                featuresSection.classList.remove('has-expanded');

                if (!isExpanded) {
                    card.classList.add('is-expanded');
                    featuresSection.classList.add('has-expanded');
                    if (featureAnnounce) featureAnnounce.textContent = card.querySelector('h3')?.textContent + ' expanded';
                    setTimeout(() => {
                        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }, 80);
                }
            });
        });
    }

    // Scrim click – close all expanded cards
    if (featuresScrim) {
        featuresScrim.addEventListener('click', () => {
            document.querySelectorAll('.feature-card').forEach(c => c.classList.remove('is-expanded'));
            featuresSection.classList.remove('has-expanded');
        });
    }

    // Global Escape key handler for sheets and expanded cards
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            if (featureSheet && featureSheet.classList.contains('is-open')) {
                closeSheet();
                return;
            }
            if (featuresSection.classList.contains('has-expanded')) {
                document.querySelectorAll('.feature-card').forEach(c => c.classList.remove('is-expanded'));
                featuresSection.classList.remove('has-expanded');
            }
        }
    });
});